/** Joins class names, skipping falsy values. Small enough that no dependency is needed. */
export function cx(...parts) {
  return parts
    .flat()
    .filter((part) => typeof part === "string" && part.trim() !== "")
    .join(" ");
}
